var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{directives:[{name:"prx",rawName:"v-prx:intro",value:({ r: [4, 8], tx: [-200, 0], o: [0.1, 1] }),expression:"{ r: [4, 8], tx: [-200, 0], o: [0.1, 1] }",arg:"intro"}],attrs:{"battle-academia-hero":""}})}
var staticRenderFns = []

export { render, staticRenderFns }